// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"1d27f196","883":"1d27f196","957":"1d27f196","985":"1d27f196"}[chunkId] + ".chunk.css";
};